import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2483_5840",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 25,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .888672,
				y: .875977,
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2483_5840)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12.8891 16.876C14.1391 16.876 15.2016 16.4385 16.0766 15.5635C16.9516 14.6885 17.3891 13.626 17.3891 12.376C17.3891 11.126 16.9516 10.0635 16.0766 9.18848C15.2016 8.31348 14.1391 7.87598 12.8891 7.87598C11.6391 7.87598 10.5766 8.31348 9.70156 9.18848C8.82656 10.0635 8.38906 11.126 8.38906 12.376C8.38906 13.626 8.82656 14.6885 9.70156 15.5635C10.5766 16.4385 11.6391 16.876 12.8891 16.876ZM12.8891 15.076C12.1391 15.076 11.5016 14.8135 10.9766 14.2885C10.4516 13.7635 10.1891 13.126 10.1891 12.376C10.1891 11.626 10.4516 10.9885 10.9766 10.4635C11.5016 9.93848 12.1391 9.67598 12.8891 9.67598C13.6391 9.67598 14.2766 9.93848 14.8016 10.4635C15.3266 10.9885 15.5891 11.626 15.5891 12.376C15.5891 13.126 15.3266 13.7635 14.8016 14.2885C14.2766 14.8135 13.6391 15.076 12.8891 15.076ZM12.8891 19.876C10.6557 19.876 8.61823 19.276 6.77656 18.076C4.9349 16.876 3.48073 15.2926 2.41406 13.326C2.33073 13.176 2.26823 13.0218 2.22656 12.8635C2.1849 12.7051 2.16406 12.5426 2.16406 12.376C2.16406 12.2093 2.1849 12.0468 2.22656 11.8885C2.26823 11.7301 2.33073 11.576 2.41406 11.426C3.48073 9.45931 4.9349 7.87598 6.77656 6.67598C8.61823 5.47598 10.6557 4.87598 12.8891 4.87598C15.1224 4.87598 17.1599 5.47598 19.0016 6.67598C20.8432 7.87598 22.2974 9.45931 23.3641 11.426C23.4474 11.576 23.5099 11.7301 23.5516 11.8885C23.5932 12.0468 23.6141 12.2093 23.6141 12.376C23.6141 12.5426 23.5932 12.7051 23.5516 12.8635C23.5099 13.0218 23.4474 13.176 23.3641 13.326C22.2974 15.2926 20.8432 16.876 19.0016 18.076C17.1599 19.276 15.1224 19.876 12.8891 19.876Z",
				fill: "black"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgEyeIcon);
export default ForwardRef;
